// extracted by mini-css-extract-plugin
export default {"features__section":"styles_features__section__KvqlI","icon":"styles_icon__A+LeB","card":"styles_card__5iwWX","is_rtl":"styles_is_rtl__widTn"};